import { AbstractTotalWinCounterProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTotalWinCounterProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
/**
 * Custom properties for the game's total win counter.
 */
export class GameTotalWinCounterProperties extends AbstractTotalWinCounterProperties {
    constructor() {
        super();
        this.titleFieldProperties = new TextFieldProperties(GameFontStyle.TOTAL_WIN_TITLE, new Point(0, -45), GameLang.WIN_LABEL, ControlConstants.CENTER, ControlConstants.CENTER, new Point(300, targetHeight));
        this.valueFieldProperties = new TextFieldProperties(GameFontStyle.TOTAL_WIN_VALUE, new Point(0, 15), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(300, targetHeight));
        this.backgroundProperties.anchor.set(0.5);
        this.titleFieldProperties.position.y -= this.titleFieldProperties.size.y / 2;
        this.valueFieldProperties.position.y -= this.valueFieldProperties.size.y / 2;
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
const panelHeight = 177;
const targetHeight = (panelHeight - panelHeight * 0.2) / 2; //Half the height with a bit of padding applied
//# sourceMappingURL=GameTotalWinCounterProperties.js.map